import {HTMLAttributes} from 'react';
import styled from 'styled-components';
import {typographyStyle} from '@/components/Typography';
import {FlexCenter, interceptProps} from '@/styled-components';
import {palette} from '@/styles';

interface IProps extends HTMLAttributes<HTMLDivElement> {
  name?: string;
  icon?: string;
  color?: string;
  size?: 'large' | 'small';
}

export const MarkerContent = ({
  icon,
  name = '',
  color,
  children,
  ...props
}: IProps) => {
  return (
    <Content style={{...props?.style, backgroundColor: color}} {...props}>
      {!!children ? (
        children
      ) : !!icon?.length ? (
        <img src={icon} alt={name} />
      ) : (
        name.slice(0, 1)
      )}
    </Content>
  );
};

const Content = styled(FlexCenter).withConfig({
  shouldForwardProp: interceptProps(['size']),
})<{
  size?: IProps['size'];
}>`
  border-radius: 100%;
  border: 1px solid ${palette.white};
  color: ${palette.white};
  background-color: ${palette.teal100};
  font-weight: 700;
  img {
    width: 80%;
    height: 80%;
    border-radius: 100%;
  }
  ${{...typographyStyle.medium12}}
  ${({size = 'large'}) =>
    size === 'small'
      ? `width: 16px; height: 16px; border-color: ${palette.gray200};`
      : `width: 22px; height: 22px;`}
`;
